// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/anchor');
require('@js/ajax-posts');
require('@js/toc');
